import { Box, Stack, Typography } from '@mui/material'
import { formatPlanPeriod, formatPlanPrice, usePlanConfig } from 'hooks/usePublicConfig'
import { TRAINEE_PLAN, UserSubscription } from 'types'
import { formatDate } from 'utils'
import { getPlanDisplayName } from '../constants'

/**
 * Plan section for an individual trainee. They have a single plan, so this is the caregiver
 * section minus everything that only makes sense with a choice: no plan selector, no pending-plan
 * schedule, no Family seats. The price comes from the public config rather than a constant.
 */
export function TraineeSubscriptionSection({ subscription }: { subscription: UserSubscription }) {
  const plan = usePlanConfig(TRAINEE_PLAN)

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Active Plan: {getPlanDisplayName(subscription.plan)}
      </Typography>

      <Stack spacing={2}>
        <Box>
          <Typography variant="body2" color="text.secondary">
            Renewal date
          </Typography>
          <Typography variant="body1">
            {formatDate(subscription.currentPeriodEnd, 'MM.DD.YY')}
          </Typography>
        </Box>

        {plan && (
          <Box>
            <Typography variant="body2" color="text.secondary">
              Your subscription automatically renews for {formatPlanPrice(plan)} per{' '}
              {formatPlanPeriod(plan)} on the renewal date.
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              Final amount may include applicable taxes and fees.
            </Typography>
          </Box>
        )}
      </Stack>
    </Box>
  )
}
